module.exports = __webpack_public_path__ + "static/media/fourImage.1308dd38.jpg";